import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string | null;
  children: ReactNode;
}

export function FormField({ label, htmlFor, error, children }: FormFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={htmlFor} className="text-sm font-medium">
        {label}
      </label>
      {children}
      {error ? <p className="text-xs text-[color:var(--color-danger)]">{error}</p> : null}
    </div>
  );
}

export const inputClasses = cn(
  'h-11 w-full rounded-xl border border-[color:var(--color-border)]',
  'bg-[color:var(--color-bg-elevated)] px-4 text-base',
  'text-[color:var(--color-fg)] placeholder:text-[color:var(--color-fg-muted)]',
  'outline-none focus:border-[color:var(--color-accent)]',
  'disabled:opacity-60 disabled:cursor-not-allowed',
);

export const primaryButtonClasses = cn(
  'inline-flex h-11 w-full items-center justify-center gap-2 rounded-xl',
  'bg-[color:var(--color-accent)] font-medium text-[color:var(--color-accent-fg)]',
  'transition active:scale-[0.99]',
  'disabled:opacity-70 disabled:pointer-events-none',
);

export function ButtonSpinner({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className="animate-spin"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="3"
        strokeOpacity="0.25"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
